import mixpanel from 'mixpanel-browser';

export { mixpanel };
